var render = function render(_c,_vm){return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48","aria-hidden":"true","fill":"currentColor"}},[_c('path',{attrs:{"d":"M2.667 48v-4h42.667v4ZM24 40 11.067 27.067l2.867-2.867 8.067 8.067V0h4v32.267l7.8-7.8 2.866 2.866Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }